import { renderInDocument } from '@spotahome/soyuz/client';

import StaticPageContainer from './main';

renderInDocument(StaticPageContainer);
